import AccessDenied from './AccessDenied';

export { AccessDenied };
